import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { PlanetProps } from "Data/planet";
import TextParagraph from "./Text/TextParagraph";
import { is_touch_device } from "../util";
import media from "Styles/media";
import { getHoverId } from "Threejs/listArrayRender";
import theme from "Styles/theme";

interface PlanetListProps {
	data: PlanetProps;
	index: number;
	className?: string;
	ratio: number;
	col: number;
	onClick: () => void;
}

const Descript = styled.div`
	font-size: 12px;
	font-weight: 100;
	font-family: ${(props) => props.theme.font.inconsolata};
	display: flex;

	flex-direction: column;
	align-items: flex-end;
`;

const List = styled.li<{ ratio: number; width: number }>`
	position: relative;
	width: ${(props) => `${props.width}%`};
	${(props) => props.theme.layout.ratio(props.ratio)};
	cursor: pointer;

	@media ${media.mobile} {
		max-height: 250px;
	}
`;

const ListDiv = styled.div<{ active: boolean }>`
	position: absolute;
	bottom: 0;

	opacity: ${(props) => (props.active ? 1 : 0)};
`;

const ListDivLeft = styled(ListDiv)`
	left: 0;
`;
const ListDivRight = styled(ListDiv)`
	right: 0;
`;

const Div = styled.div`
	position: absolute;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
	width: 10px;
	height: 0.5px;
	background-color: ${(props) => props.theme.color.gray.light};
`;

const DivVer = styled(Div)`
	transform: translate(-50%, -50%) rotate(90deg);
`;
const DivHor = styled(Div)``;

const AbsoluteWrapper = styled.div`
	position: absolute;
	left: 0;
	top: 0;
	width: 100%;
	height: 100%;
`;

const Info = styled(AbsoluteWrapper)`
	padding: 12px;
	padding-left: 20px;
	color: ${(props) => props.theme.color.white};
	display: flex;
	flex-direction: column;
	justify-content: space-between;
	z-index: 1;
	${(props) => props.theme.event.disable};

	@media ${media.mobile} {
		padding-left: 12px;
		padding: ${(props) => `${props.theme.size.offset.tablet}px`};
	}
`;

const InfoKeyValue = styled(TextParagraph)``;

const Header = styled.div``;

const PlanetList: React.FC<PlanetListProps> = ({ data, index, className, ratio, col, onClick }) => {
	const {
		color,
		satellite,
		ring,
		contents: {
			title,
			user: { name }
		}
	} = data;
	const radius = theme.size.three.planet_radius;

	const [isHover, setIsHover] = useState(false);

	useEffect(() => {
		if (is_touch_device()) setIsHover(true);
	}, []);

	const handlehoverIn = (id: string) => {
		if (!is_touch_device()) {
			setIsHover(true);
			getHoverId(id);
		}
	};
	const handleHoverOut = () => {
		if (!is_touch_device()) {
			setIsHover(false);
			getHoverId("");
		}
	};

	const handleTouchEnd = () => {
		if (!is_touch_device()) {
			setIsHover(true);
		}
	};

	const handleListClick = () => {
		onClick();
	};

	return (
		<List className={`${className}`} ratio={ratio} width={100 / col} onClick={handleListClick} onMouseEnter={() => handlehoverIn(data.id)} onMouseOut={handleHoverOut} onTouchEnd={handleTouchEnd}>
			<ListDivLeft active={true}>
				<DivVer />
				<DivHor />
			</ListDivLeft>

			<ListDivRight active={index % col === col - 1}>
				<DivVer />
				<DivHor />
			</ListDivRight>

			<Info>
				<Header>
					<TextParagraph value={title} />
					<TextParagraph value={name} bold={true} size={14} />
				</Header>
				<Descript>
					{/*<InfoKeyValue value={!isHover ? "" : `size _ ${radius}`} effect={is_touch_device() ? false : true} />*/}
					<InfoKeyValue value={!isHover ? "" : `color _ ${color}`} effect={is_touch_device() ? false : true} />
					<InfoKeyValue value={!isHover ? "" : `satellite _ ${!!satellite}`} effect={is_touch_device() ? false : true} />
					<InfoKeyValue value={!isHover ? "" : `ring _ ${!!ring}`} effect={is_touch_device() ? false : true} />
				</Descript>
			</Info>
		</List>
	);
};

export default PlanetList;
